<template>
  <div>
      <div v-if="!hasChildren" class="p-0 bg-darkBlue">

              <div class="container-fluid g-0 p-0 m-0">
                  <img :src="`${publicPath}img/portadaFullPhone_${locale}.jpg`" class="img-responsive d-block d-md-none">
                  <img :src="`${publicPath}img/portadaFull_${locale}.jpg`" class="img-responsive d-none d-md-block">
                  <div class="row g-0">
                      <div class="col-10 col-xl-8 col-xxl-6 m-auto text-white">
                          <p v-html="$t('home.intro')"></p>
                      </div>
                  </div>
              </div>
              <div class="contingut bg-darkBlue row g-0 pb-5">

                  <hr>
                  <div class="row p-0 g-0">
                      <div class="col-12 p-3 p-lg-0 m-0 pb-3 text-end">
                          <localized-link class="footerLink" to="/roca-group-2021/presentacion">{{ $t("nav.presentacion") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
                      </div>
                  </div>
              </div>

      </div>
  </div>
  <router-view></router-view>
</template>

<script>
//import Presentacion from '@/views/rocagroup/PresentacionView.vue'
export default {
  name: "RocaGroup2021View",
  components: {
    //Presentacion
  },
  props: {
    hasChildren: Boolean
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      locale:this.$i18n.locale,
    }
  }
}
</script>
